import React from 'react';
import '../../App.css';
import { Row, Col } from 'reactstrap';
import aparat from '../../images/aparat.png';
import insta from '../../images/insta.png';
import telegram from '../../images/telegram.png';
import bazar from '../../images/bazar.png';
import sibapp from '../../images/sibapp.png';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js'
import {framework} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.username = "نام کاربر";
    this.toggle = this.toggle.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.state = {
        isOpen: false,
        visible:UserManager.isLogin(),
        modal: false,
        nestedModal: false,
        closeAll: false
    };
    this.logOutoutStatus = this.logOutoutStatus.bind(this);
    this.changeLoginStatus = this.changeLoginStatus.bind(this);
    UserManager.dispatcher.addEventListner(UserManager.LOGGED_IN,this.changeLoginStatus);
    UserManager.dispatcher.addEventListner(UserManager.LOGGED_OUT,this.logOutoutStatus);
this.toggleNested = this.toggleNested.bind(this);
this.toggleAll = this.toggleAll.bind(this);
}

changeLoginStatus()
{
    this.setState(
        {
            visible: true
        }
    );
}
logOutoutStatus()
{
    this.setState(
        {
            visible: false
        }

    );
}

toggle() {
    // this.setState(prevState => ({
    //     dropdownOpen: !prevState.dropdownOpen
    // }));
    this.setState({
    isOpen: !this.state.isOpen
    });
}
toggle2() {
    this.setState({
    modal: !this.state.modal
    });
}
toggleNested() {
    this.setState({
      nestedModal: !this.state.nestedModal,
      closeAll: false
    });
  }

  toggleAll() {
    this.setState({
      nestedModal: !this.state.nestedModal,
      closeAll: true
    });
}
render() {
  return (
    <section className="footer">

      <Row>
        <Col sm="12" md="4">
          <Row className="titr-row">
            <Col sm="12">
              <h5>ارتباط با ما</h5>
            </Col>
          </Row>
          <span><strong>آدرس:</strong> تهران - بلوار میرداماد - میدان مادر - خیابان شهید سنجابی - نبش کوچه یکم - پلاک 11
            <br />
            <strong>خط ویژه:</strong> 02123047  - <strong>تلفن:</strong> 02122277775
            <br />
            <strong>وبسایت :</strong> www.novininsurance.com
          </span>
        </Col>
        <Col sm="12" md="4">
          <Row className="titr-row">
            <Col sm="12">
              <h5>شبکه های اجتماعی</h5>
            </Col>
          </Row>
          <span>
            <ul>
              <li><a href=""><img  alt="" src={aparat} /></a></li>
              <li><a href=""><img  alt="" src={insta} /></a></li>
              <li><a href=""><img  alt="" src={telegram} /></a></li>
            </ul>
          </span>
        </Col>
        <Col sm="12" md="4">
          <Row className="titr-row">
            <Col sm="12" >
              <h5>دانلود اپلیکیشن</h5>
            </Col>
          </Row>
          <span className="dl-links">
            <a href="https://cafebazaar.ir/app/air.com.mteamapps.BimeNovin/?l=fa" rel="noopener noreferrer" className="dl-link" target="_blank"><img  alt="" src={bazar} /></a>
            <a href="https://sibapp.com/applications/%D8%A8%DB%8C%D9%85%D9%87-%D9%86%D9%88%DB%8C%D9%86" rel="noopener noreferrer" className="dl-link" target="_blank"><img  alt="" src={sibapp} /></a>
          </span>

        </Col>
      </Row>
      <Row>
        <Col sm="12">
        
            <div className="footer_menu">
           
            <div onClick={() => PageManager.changePage(Config.p_pishnahad)} >
                <span>پیشنهادات و انتقادات</span>
            </div>
            <div onClick={() => PageManager.changePage(Config.p_search)} >
                <span>جستجو</span>
            </div>
            </div>
          
        </Col>
      </Row>
    </section>

  );
}
}

export { Footer };


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js